// extracted by mini-css-extract-plugin
export var addButton = "_iv-0";
export var border = "_iv-8";
export var check = "_iv-h";
export var danger = "_iv-6";
export var dropdownContainer = "_iv-1";
export var editModalBody = "_iv-j";
export var footerContainer = "_iv-i";
export var fullWidth = "_iv-a";
export var hide = "_iv-9";
export var icon = "_iv-3";
export var input = "_iv-7";
export var inputFlex = "_iv-b";
export var inputWrapper = "_iv-c";
export var manualFocus = "_iv-5";
export var optionButton = "_iv-4";
export var pillWrapper = "_iv-e";
export var pointer = "_iv-2";
export var showOverflow = "_iv-f";
export var tagsFlex = "_iv-d";
export var xButton = "_iv-g";